import { Loader } from '@googlemaps/js-api-loader';
import { LanguageRegionToken } from '@rx-applications/clientsite/shared/internationalization/utils';

export function googleMapsLoaderFactory({ language, region }: LanguageRegionToken) {
  return () => {
    const loader = new Loader({
      apiKey: 'AIzaSyCt0FGQxjgdx2xgbni0VtELXqFqWKaaea4',
      language,
      region,
      version: 'weekly',
    });
    return Promise.all([loader.importLibrary('maps')]);
  };
}
